import { useEffect } from 'react';
import { auth } from 'config/firebase';

export default function useTabFocus() {
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden && auth.currentUser) {
        auth.currentUser.getIdToken(true).catch(console.error);
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);
}
